module.exports = "<div class=toast-container> <div class=toast-message></div> </div>";